// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;


// i18n
//   .use(LanguageDetector) // Automatically detect language
//   .use(initReactI18next) // Passes i18n down to react-i18next
//   .init({
//     resources: {
//       en: {
//         translation: {
//           welcome: "Welcome",
//         },
//       },
//       hi: {
//         translation: {
//           welcome: "स्वागत है",
//         },
//       },
//       kok: {
//         translation: {
//           welcome: "स्वागतम्", // Konkani (in Devanagari script)
//         },
//       },
//     },
//     fallbackLng: 'en',
//     interpolation: {
//       escapeValue: false, // React already escapes
//     }
//   });

// export default i18n;
